import React, { useContext } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import MyWorkContext from '@totem/components/users/myWork/MyWorkContext';
import MyWorkTable from '@totem/components/users/myWork/MyWorkTable';

export const MyWorkExtra = () => {
  const { totalRecords, onRefresh } = useContext(MyWorkContext);

  return (
    <Space>
      <RecordCountBadge count={totalRecords} />
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

const MyWorkLayout = () => <MyWorkTable />;

export default MyWorkLayout;
